import { render } from "./Promo.vue?vue&type=template&id=f3637868&scoped=true"
import script from "./Promo.vue?vue&type=script&lang=js"
export * from "./Promo.vue?vue&type=script&lang=js"

import "./Promo.vue?vue&type=style&index=0&id=f3637868&scoped=true&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3637868"]])

export default __exports__